module.exports = __webpack_public_path__ + "img/5.369f47ad.png";